<script>
export default {
  props: {
    btnText: {
      type: String,
      default: ''
    },
    btnType: {
      type: String,
      default: ''
    },
    btnSize: {
      type: String,
      default: ''
    },
    btnOutline: {
      type: String,
      default: ''
    },
    btnActive: { },
    btnBlock: { }
  },
  computed: {
    // 控制按鈕的型別
    computedType: function () {
      return this.btnType ? `btn-${this.btnType}` : ''
    },
    // 控制按鈕大小尺寸
    computedSize: function () {
      return this.btnSize ? `btn-${this.btnSize}` : ''
    },
    // 控制按鈕邊框
    computedOutline: function () {
      return this.btnOutline ? `btn-outline-${this.btnOutline}` : ''
    },
    // 控制按鈕是否啟用
    computedActive: function () {
      return this.btnActive === 'true' ? 'active' : ''
    },
    // 控制按鈕是否是塊元素
    computedBlock: function () {
      return this.btnBlock === 'true' ? 'btn-block' : ''
    }
  }
}
</script>

<template>
  <button
    type="button"
    class="btn"
    :class='[computedType, computedSize, computedOutline, computedActive, computedBlock]'
  >
    {{ btnText }}
    <slot name="eg" />
    <slot name="icon" />
  </button>
</template>
